const norm = (s: string) => s.trim().toLowerCase();

/** "Untitled", then "Untitled 2", "Untitled 3"… the first name not already taken in the project (backlog §19). */
export function nextUntitled(base: string, taken: readonly string[]): string {
  const used = new Set(taken.map(norm));
  if (!used.has(norm(base))) return base;
  let n = 2;
  while (used.has(norm(`${base} ${n}`))) n++;
  return `${base} ${n}`;
}
